export default __webpack_public_path__ + "static/media/twitter.14976e97.svg";